import {
  IProductPage as IContentfulProductPage,
  IEntry,
} from 'marketing-site/@types/generated/contentful'
import { IProductPage } from 'marketing-site/src/components/common/pages/ProductPage'
import { transformProduct } from '../models/ContentfulProduct'

export function isProductPage(entry: IEntry): entry is IContentfulProductPage {
  return entry.sys.contentType?.sys.id === 'productPage'
}

export function transformProductPage({ fields }: IContentfulProductPage): IProductPage {
  return {
    ...fields,
    product: transformProduct(fields.product),
  }
}
